import dayjs from 'dayjs';

const dateParser = (date) => {
  const formattedDate = dayjs(date).format('dddd, MMM. D, YYYY');
  return formattedDate;
}

export default dateParser
